import { render, staticRenderFns } from "./RewardsMoneyModal.vue?vue&type=template&id=de56e6a6&"
import script from "./RewardsMoneyModal.vue?vue&type=script&lang=js&"
export * from "./RewardsMoneyModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports